import {Modal} from "@mantine/core";
import './notifierModal.css'
// @ts-ignore
import {Device} from "./device/device";


export function NotifierModal({opened, onClose}: { opened: boolean, onClose: () => void }) {

    return (
        <Modal
            opened={opened}
            size={"80%"}

            onClose={() => onClose()}
            title="Introduce yourself!"
        >
            <div className={"notifier-modal-parent"}>
                <div style={{height: "80vh"}}>
                    <Device/>
                </div>

            </div>

        </Modal>
    )

}
